import { Controller } from "@hotwired/stimulus"

// Podgląd sygnału dźwiękowego w personalizacji powiadomień: odtwarza dźwięk wybrany
// w selekcie (po zmianie wyboru i po kliknięciu "Zagraj"). Sam zapis wyboru robi
// IntumJs.setField w onchange selecta - tutaj tylko odtwarzanie.
export default class extends Controller {
  static targets = ["select"]
  static values = { urls: Object }

  // URL sygnału wybranego w selekcie; null dla kodu bez pliku (sygnał zniknął z repo)
  soundUrl() {
    return this.urlsValue[this.selectTarget.value] || null
  }

  play() {
    const url = this.soundUrl()
    if (!url) { return }

    // nowy Audio przy każdym odtworzeniu - inaczej szybkie kliknięcia ucinają dźwięk
    const audio = new Audio(url)
    audio.play().catch(error => console.error("Error playing sound:", error))
  }
}
